// __BILLED_LIST__ (2026-10-03) Henry: "We can add another list for billed or archived."
// The Archive view's lists over the FINISHED jobs (the operational statuses stay on the
// Kanban). Pure - sim/archivelists.test.mjs.
//   to_bill : complete jobs waiting to be billed (what the hub's Hauling Board tab pulls);
//             ready_to_bill is retired but an old row still shows here, as complete;
//   billed  : billed + archived, newest billed first, dated by billed_at;
//   all     : every finished job.
export const ARCHIVE_LISTS = {
  to_bill: { label: 'Completed — to bill', statuses: ['complete', 'ready_to_bill'], dateCol: 'completed_at' },
  billed: { label: 'Billed / Archived', statuses: ['billed', 'archived'], dateCol: 'billed_at' },
  all: { label: 'All finished', statuses: ['complete', 'ready_to_bill', 'billed', 'archived'], dateCol: 'completed_at' },
  // __STATUS_TRUTH__ (2026-10-28) a cancelled job was on no column and no list anywhere on the board
  cancelled: { label: 'Cancelled', statuses: ['cancelled'], dateCol: 'created_at' },
};

export const ARCHIVE_LIST_ORDER = ['to_bill', 'billed', 'all', 'cancelled'];

export const archiveList = (key) => ARCHIVE_LISTS[key] || ARCHIVE_LISTS.to_bill;

// The route a finished job was driven on, e.g. 'RT-2026-09-29-028F #3' (its place in the
// route), or ''. Routes stay together on the board; billing still bills each job on its own.
export const routeLabelOf = (job) => {
  const rl = job && Array.isArray(job.route_loads) ? job.route_loads : [];
  const hit = rl.find((r) => r && r.routes && r.routes.route_number);
  if (!hit) return '';
  return hit.routes.route_number + (hit.sequence_order ? ' #' + hit.sequence_order : '');
};

// The job's price: final, else quoted, else null (loads has no 'rate' column).
export const jobPriceOf = (job) => {
  for (const k of ['final_price', 'quoted_price']) {
    const v = job ? parseFloat(job[k]) : NaN;
    if (Number.isFinite(v) && v > 0) return v;
  }
  return null;
};

// The driver's name: the drivers row's own name (every driver has one, a login or not),
// else the linked login's profile name.
export const driverNameOf = (job) =>
  (job && job.driver && (job.driver.name || (job.driver.user && job.driver.user.name))) || '';
